export default "76799cf35920ead3.png"